import { Button } from "@/components/ui/button";
import { useQueryParkingLot } from "modules/curb-zone/hooks/use-query-parking-lot";
import { useState } from "react";
import { ParkingLot } from "services/web/api-parking-lot.type";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import * as React from "react";

interface ParkingLotDetailProps {
  parkingLotDetail?: ParkingLot;
  setParkingLotDetail: (params: ParkingLot | undefined) => void;
  setOpenParkingLotModal: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ParkingLotDetail = ({
  parkingLotDetail,
  setParkingLotDetail,
  setOpenParkingLotModal,
}: ParkingLotDetailProps) => {
  const { handleDeleteParkingLot } = useQueryParkingLot();
  const [openConfirm, setOpenConfirm] = useState(false);
  const handleDelete = async () => {
    if (parkingLotDetail?.id) {
      handleDeleteParkingLot({ id: parkingLotDetail.id });
      setOpenConfirm(false);
      setParkingLotDetail(undefined);
    }
  };
  return (
    <>
      <div className="transition-opacity absolute h-auto top-36 bg-primary p-3 right-6 mt-2 mb-3 rounded-md shadow-lg z-5 min-w-80">
        <div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Name</span>
            <span className="text-sm text-secondary text-right">{parkingLotDetail?.name}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Address</span>
            <span className="text-sm text-secondary text-right">{parkingLotDetail?.address}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Note</span>
            <span className="text-sm text-secondary text-right">{parkingLotDetail?.note}</span>
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <Button variant="destructive" onClick={() => setOpenConfirm(true)}>
            Delete
          </Button>
          <Button variant="secondary" onClick={() => setOpenParkingLotModal(true)}>
            Edit
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete parking lot</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete this parking lot?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setOpenConfirm(false)}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleDelete}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
